export class OrbiMessageCode {
}
OrbiMessageCode.SomeMessageCode = 10000;
;
